import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Url } from '../../models/url';
import { ConfigurationService } from '../../../entry-routes/configuration/configuration.service';
import { DataResponseTaskResponse } from '../../models/workflow/dataResponseTaskResponse';
import { Configuration } from '../../models/workflow/configuration';
import { TaskQueryRequest } from '../../models/workflow/taskQueryRequest';
import { TaskResponse } from '../../models/workflow/taskResponse';
import { TaskActionRequest } from '../../models/workflow/taskActionRequest';
import { TaskDisplayedColumnsDef } from '../../models/workflow/taskDisplayedColumnsDef';
import {SocketService} from '../socket/socket.service';
import { FileRefsForMerge } from '../../models/workflow/fileRefsForMerge';

@Injectable({
  providedIn: 'root'
})
export class WkfTaskService {

  protected basePath ;
  public configuration = new Configuration();

  constructor(
    private httpClient: HttpClient,
    private configAction: ConfigurationService,
   private socketService: SocketService,
   @Optional() configuration: Configuration
  ) {
      if (configuration) {
        this.configuration = configuration;
      }
  }

  private getBasePath(): string {
    if (!this.basePath) {
      const flowableProtectedApiBaseUrl = Url.getFlowableProtectedApiBaseUrl(this.configAction);
      console.debug('WkfTaskService, flowableProtectedApiBaseUrl : '+flowableProtectedApiBaseUrl);
      this.basePath =  flowableProtectedApiBaseUrl + Url.WKF_PROCESS_API;
    }
    console.debug('WkfTaskService, this.basePath : '+this.basePath);
    return this.basePath;
  }

  /*
  Recup des colonnes pour la grille
   */
  getTaskMatTableColumnDefs( currentDomain: string ) : Observable<TaskDisplayedColumnsDef> {
    const chunkHeaders: HttpHeaders = new HttpHeaders();

    const params = new HttpParams().set("_domains",currentDomain);

    return this.httpClient.get<TaskDisplayedColumnsDef>(Url.getFlowableProtectedApiBaseUrl(this.configAction)+Url.WKF_NEXIA_API+'/'+Url.TASKS+'columns',{headers: chunkHeaders, params: params});
  }

  /**
   * Query for tasks
   * All supported JSON parameter fields allowed are exactly the same as the parameters found for getting a collection of tasks (except for candidateGroupIn which is only available in this POST task query REST service), but passed in as JSON-body arguments rather than URL-parameters to allow for more advanced querying and preventing errors with request-uri’s that are too long. On top of that, the query allows for filtering based on task and process variables. The taskVariables and processInstanceVariables are both JSON-arrays containing objects with the format as described here.
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTasks(body?: TaskQueryRequest, observe?: 'body', reportProgress?: boolean): Observable<DataResponseTaskResponse>
  //;
  //public queryTasks(body?: TaskQueryRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataResponseTaskResponse>>;
  //public queryTasks(body?: TaskQueryRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataResponseTaskResponse>>;
  //public queryTasks(body?: TaskQueryRequest, observe: any = 'body', reportProgress = false ): Observable<any>
  {
    return this.httpClient.post<DataResponseTaskResponse>(`${this.getBasePath()}/query/tasks`,
      body,
      {
        withCredentials: this.configuration.withCredentials,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get a task form
   *
   * @param taskId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTaskForm(taskId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
  public getTaskForm(taskId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
  public getTaskForm(taskId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
  public getTaskForm(taskId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling getTaskForm.');
    }

    let headers = new HttpHeaders();

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }


    // to determine the Content-Type header
    /*
    const consumes: string[] = [
    ];
    */

    //return this.httpClient.get<string>(`${this.getBasePath()}/runtime/${Url.TASKS}${encodeURIComponent(String(taskId))}/form`,
    return this.httpClient.get<string>(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_TASK_FORM +`${encodeURIComponent(String(taskId))}/form`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }


  /**
   * Tasks actions
   *
   * @param taskId
   * @param body
   * @param waitFor flag to wait response from socket
   */
  // public executeTaskAction(taskId: string, body?: TaskActionRequest, observe?: 'body', reportProgress?: boolean): Observable<UserSocketHttpResponse>;
  // public executeTaskAction(taskId: string, body?: TaskActionRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSocketHttpResponse>>;
  // public executeTaskAction(taskId: string, body?: TaskActionRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSocketHttpResponse>>;
  public executeTaskAction(taskId: string, body?: TaskActionRequest, waitFor = true ): Observable<any> {

    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling executeTaskAction.');
    }


    let headers = new HttpHeaders();

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }


    //return this.httpClient.post<any>(`${this.getBasePath()}/runtime/${Url.TASKS}${encodeURIComponent(String(taskId))}`,
    if (waitFor) {
      return this.socketService.post(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_TASK + `${encodeURIComponent(String(taskId))}`,
        body,
        {
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: 'body'
        }
      );
    } else {
      return this.httpClient.post(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_TASK + `${encodeURIComponent(String(taskId))}`,
        body,
        {
          withCredentials: this.configuration.withCredentials,
          headers: headers,
          observe: 'body'
        }
      );
    }
  }


  /**
   * Tasks actions
   *
   * @param taskId
   * @param body
   * @param waitFor flag to wait response from socket
   */
  public executeTaskBulkCompleteAction(taskId: string, body?: TaskActionRequest, waitFor = true ): Observable<any> {

    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling executeTaskAction.');
    }


    let headers = new HttpHeaders();

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }


    //return this.httpClient.post<any>(`${this.getBasePath()}/runtime/${Url.TASKS}${encodeURIComponent(String(taskId))}`,
    if (waitFor) {
      return this.socketService.post(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_TASK + Url.WKF_TASK_BULK_COMPLETE + `${encodeURIComponent(String(taskId))}`,
          body,
          {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: 'body'
          }
      );
    } else {
      return this.httpClient.post(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_TASK + Url.WKF_TASK_BULK_COMPLETE + `${encodeURIComponent(String(taskId))}`,
          body,
          {
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: 'body'
          }
      );
    }
  }

  /**
   * Get a task
   *
   * @param taskId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTask(taskId: string, observe?: 'body', reportProgress?: boolean): Observable<TaskResponse>;
  public getTask(taskId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TaskResponse>>;
  public getTask(taskId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TaskResponse>>;
  public getTask(taskId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling getTask.');
    }

    let headers = new HttpHeaders();

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }


    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    /*
    const consumes: string[] = [
    ];
    */

    //return this.httpClient.get<TaskResponse>(`${this.getBasePath()}/runtime/${Url.TASKS}${encodeURIComponent(String(taskId))}`,
    return this.httpClient.get<TaskResponse>(Url.getFlowableProtectedApiBaseUrl(this.configAction) +Url.WKF_TASK+`${encodeURIComponent(String(taskId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  public getSubTasks(taskId: string, observe: any = 'body', reportProgress = false ): Observable<any> {

    if (taskId === null || taskId === undefined) {
      throw new Error('Required parameter taskId was null or undefined when calling getTask.');
    }

    let headers = new HttpHeaders();

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }


    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'application/json'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.get<TaskResponse>(Url.getFlowableProtectedApiBaseUrl(this.configAction) +Url.WKF_TASK+`${encodeURIComponent(String(taskId))}/subtasks`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

    mergeForPrint( selectedProcessInstanceIds: FileRefsForMerge ) : Observable<HttpResponse<ArrayBuffer>> {
      return this.httpClient.post(Url.getFlowableProtectedApiBaseUrl(this.configAction) + Url.WKF_NEXIA_API + '/' + Url.WKF_FILE_MERGE ,
          selectedProcessInstanceIds,
          {
            observe: 'response',
            responseType: 'arraybuffer'
          });
    }

    mergeForPrintMock( selectedProcessInstanceIds: FileRefsForMerge ) : Observable<HttpResponse<ArrayBuffer>> {
      console.debug('mergeForPrintMock selectedProcessInstanceIds:', selectedProcessInstanceIds);
      return this.httpClient.get('./assets/mock/images/invoice3.pdf' ,
        {
          observe: 'response',
          responseType: 'arraybuffer'
        });
  }
}


